{
  "progress_tracker": {
    "title": "Titre",
    "in_progress": "En cours",
    "description": "Description",
    "empty_alt": "Vide",
    "add_contacts_to_list": "Ajouter des contacts à la liste",
    "add_contacts_count": "Nombre de contacts à ajouter"
  }
}
